import React from "react";
import moment from "moment";
import {Table, Text, TextAs, TextSizes, EmptyState} from "@clockout-dev/design-elements";
import JobStatusPill from "./JobStatusPill";
import {buildJobRowModel} from "../../audit.model";
import styles from "../../styles/document-audit.module.scss";

/**
 * The selected member's real intake jobs (clone of the reports users-table
 * chrome: HISTORY variant, row click selects, selected row highlighted).
 * The jobs endpoint returns the full list in one response, so there is no
 * server pagination — antd pages client-side past 10 rows.
 *
 * @param {Object} props
 * @param {Object[]} props.jobs
 * @param {boolean} [props.loading]
 * @param {string | null} [props.selectedJobId]
 * @param {(jobId: string) => void} props.onSelectJob
 */
function IntakeJobsTable({jobs = [], loading = false, selectedJobId = null, onSelectJob}) {
    const columns = [
        {
            title: "Date",
            dataIndex: "created_at",
            key: "created_at",
            render: value => {
                const parsed = value ? moment(value) : null;
                return (
                    <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.dateCell}>
                        {parsed?.isValid() ? parsed.format("MMM D, YYYY HH:mm") : "—"}
                    </Text>
                );
            }
        },
        {
            title: "Dimension",
            dataIndex: "dimension",
            key: "dimension",
            render: value => (
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.dimensionCell}>
                    {value || "—"}
                </Text>
            )
        },
        {
            title: "Filename",
            dataIndex: "filename",
            key: "filename",
            render: value => (
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.filenameCell} title={value || undefined}>
                    {value || "—"}
                </Text>
            )
        },
        {
            title: "Status",
            key: "status",
            render: (_, job) => <JobStatusPill job={job} />
        },
        {
            title: "Retention",
            key: "retention",
            render: (_, job) => (
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.retentionCell}>
                    {buildJobRowModel(job).retentionLabel}
                </Text>
            )
        },
        {
            title: "Batch",
            dataIndex: "batch_id",
            key: "batch_id",
            render: value =>
                value ? (
                    <span className={styles.batchChip} title={value}>
                        {String(value).slice(0, 8)}
                    </span>
                ) : (
                    <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL}>
                        —
                    </Text>
                )
        }
    ];

    return (
        <Table
            columns={columns}
            dataSource={jobs}
            loading={loading}
            rowKey="id"
            emptyState={<EmptyState title="No uploads found for this member." />}
            classNames={{shell: styles.tableShell, root: styles.tableRoot}}
            onRow={job => ({onClick: () => onSelectJob?.(job.id)})}
            rowClassName={job => (job?.id && job.id === selectedJobId ? styles.rowSelected : "")}
        />
    );
}

export default IntakeJobsTable;
